import React from "react";
import { Card, CardContent, CardDescription, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ShoppingCart } from "lucide-react";
import { Link } from "react-router-dom";
import { ProductCardProps } from "@/types/AppTypes";
import { cn } from "@/lib/utils";
import { useCartManagement } from "@/hooks";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import capitalizeWords from "@/utils/helper/capitalizeWords";
import { addToCart as addToCartRedux } from "@/store/slices/appSlice";

const ProductCard: React.FC<ProductCardProps> = ({
  id = "",
  brand = "",
  name = "",
  price = 0,
  description = "",
  image = "",
  className = "",
  product = {},
  onAddToCart = () => {},
}) => {
  const { addToCart : addToCartBackend, isAuthenticated } = useCartManagement();
  const {brandsMap} = useAppSelector((state) => state.app);
  const dispatch = useAppDispatch();
  const handleAddToCart = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if(isAuthenticated){
      addToCartBackend(product, 1);
    }else{
      dispatch(addToCartRedux({...product, quantity: 1}));
    }
  
  };

  return (
    <>
      <Card
        className={cn(
          "overflow-hidden border rounded-lg relative h-full shadow-sm pb-6 pt-0 cursor-pointer flex flex-col",
          className
        )}
      >
        <div className="relative flex-1 flex flex-col">
          <Link to={`/product/${product?.product_id}`} className="flex-1 flex flex-col">
            {/* Brand Badge */}
            <div className="absolute top-3 left-3 z-10">
              <span className="bg-black text-white text-xs font-medium px-3 py-1 rounded-full">
                {capitalizeWords(brandsMap?.[product?.brand_id]?.name || "Brand")}
              </span>
            </div>

            {/* Image Container */}
            <div className="bg-gray-50 w-full   h-64 flex items-center justify-center border-b border-gray-200 rounded-tr-lg">
              <img
                src={product?.images[0] || "/product.png"}
                alt={product?.name || "Product Image"}
                className="h-full w-full object-cover rounded-tr-lg"
              />
            </div>

            {/* Product Details */}
            <CardContent className="px-4 flex flex-col justify-between pt-3 flex-1">
              <div>
                <CardTitle className="font-medium text-lg group-hover:text-palette-primary transition-colors">
                  {capitalizeWords(product?.name || "Product Name")}{" "}
                </CardTitle>
                <CardDescription className="text-sm text-[#888686] overflow-hidden max-w-full hyphens-auto flex flex-wrap ">
                  {/* {typeof product?.description === "string" 
                    ? parse(product.description.slice(0, 120)) 
                    : "Product Description"}... */}
                  {Object.entries(product?.attributes).map(([key, value]) => (
                    <div key={key} className="mr-4 mb-1">
                      <span className="font-semibold text-sm text-gray-700 mr-2">{key}:</span>
                      <span>{String(value)}</span>
                    </div>
                  ))}
                </CardDescription>
              </div>
            </CardContent>
          </Link>
        </div>
        {/* Button at the bottom of the card, not absolutely positioned */}
        <div className="px-4 pb-0  flex justify-end">
          <Button
            onClick={handleAddToCart}
            className="bg-black hover:bg-gray-800 text-white"
            variant="default"
          >
            <ShoppingCart className="w-4 h-4" /> Add
          </Button>
        </div>
      </Card>
    </>
  );
};

export default ProductCard;
